<h1 mat-dialog-title align="center">{{establecimiento.est_name}}</h1>
<div mat-dialog-content align="center">
    <p class="direccion">{{addressData}}</p>
    <img *ngIf="establecimiento.est_imgs !== null" src={{imgURL}} class="img">
    <img *ngIf="establecimiento.est_imgs === null" src={{imgURL}}>
</div>
<div mat-dialog-actions align="center" class="botones-container">
    <button mat-fab extended class="boton" (click)="verEstablecimiento(establecimiento.id)" tabindex="-1">
        <mat-icon>remove_red_eye</mat-icon>
        Ver
    </button>
    <button mat-fab extended *ngIf="userData.pro_id == 4 || userData.pro_id == 1" (click)="editarEstablecimiento(establecimiento.id)" class="boton" tabindex="-1">
        <mat-icon>edit</mat-icon>
        Editar
    </button>
    <button mat-fab extended class="boton verde" (click)="verEnMaps(establecimiento)" tabindex="-1">
        <mat-icon>place</mat-icon>
        Ver en Maps
    </button>
    <!--<button mat-button mat-dialog-close cdkFocusInitial>Ok</button>-->
</div>